var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._b({staticClass:"primary",on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}},'button',_vm.$attrs,false),[_vm._t("default",function(){return [_vm._v("Default")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }